/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PageProgressDto from './PageProgressDto';

/**
 * The GameSessionProgressDto model module.
 * @module model/GameSessionProgressDto
 * @version v0
 */
class GameSessionProgressDto {
    /**
     * Constructs a new <code>GameSessionProgressDto</code>.
     * @alias module:model/GameSessionProgressDto
     */
    constructor() { 
        
        GameSessionProgressDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GameSessionProgressDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GameSessionProgressDto} obj Optional instance to populate.
     * @return {module:model/GameSessionProgressDto} The populated <code>GameSessionProgressDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GameSessionProgressDto();

            if (data.hasOwnProperty('sessionId')) {
                obj['sessionId'] = ApiClient.convertToType(data['sessionId'], 'Number');
            }
            if (data.hasOwnProperty('sessionType')) {
                obj['sessionType'] = ApiClient.convertToType(data['sessionType'], 'String');
            }
            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('totalPagesVisited')) {
                obj['totalPagesVisited'] = ApiClient.convertToType(data['totalPagesVisited'], 'Number');
            }
            if (data.hasOwnProperty('visitedPages')) {
                obj['visitedPages'] = ApiClient.convertToType(data['visitedPages'], [PageProgressDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GameSessionProgressDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GameSessionProgressDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sessionType'] && !(typeof data['sessionType'] === 'string' || data['sessionType'] instanceof String)) {
            throw new Error("Expected the field `sessionType` to be a primitive type in the JSON string but got " + data['sessionType']);
        }
        if (data['visitedPages']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['visitedPages'])) {
                throw new Error("Expected the field `visitedPages` to be an array in the JSON data but got " + data['visitedPages']);
            }
            // validate the optional field `visitedPages` (array)
            for (const item of data['visitedPages']) {
                PageProgressDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} sessionId
 */
GameSessionProgressDto.prototype['sessionId'] = undefined;

/**
 * @member {String} sessionType
 */
GameSessionProgressDto.prototype['sessionType'] = undefined;

/**
 * @member {Boolean} active
 */
GameSessionProgressDto.prototype['active'] = undefined;

/**
 * @member {Number} totalPagesVisited
 */
GameSessionProgressDto.prototype['totalPagesVisited'] = undefined;

/**
 * @member {Array.<module:model/PageProgressDto>} visitedPages
 */
GameSessionProgressDto.prototype['visitedPages'] = undefined;






export default GameSessionProgressDto;

